import { Cache } from "@siteimprove/alfa-cache";
import { Node } from "@siteimprove/alfa-dom";
import { Sequence } from "@siteimprove/alfa-sequence";
import { Context } from "../../../context.js";
import { PseudoClassSelector } from "./pseudo-class.js";
const { State } = Context;
/**
 * {@link https://drafts.csswg.org/selectors/#hover-pseudo}
 */
export class Hover extends PseudoClassSelector {
    static of() {
        return new Hover();
    }
    constructor() {
        super("hover");
    }
    static _cache = Cache.empty();
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context = Context.empty()) {
        return Hover._cache.get(element, Cache.empty).get(context, () => {
            // We assume that most of the time the context is near empty and thus it
            // is inexpensive to check if something is in it.
            const hovered = Sequence.from(context.withState(State.Hover));
            return (hovered.size !== 0 &&
                element
                    .inclusiveDescendants(Node.fullTree)
                    .some((descendant) => hovered.includes(descendant)));
        });
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (Hover) {
    Hover.parse = PseudoClassSelector.parseNonFunctional("hover", Hover.of);
})(Hover || (Hover = {}));
//# sourceMappingURL=hover.js.map